const only = "__test.only__";
const title = "__test.title__";
const cases = "__test.cases__";
const defaultExport = "default";
const moduleTag = "Module";

/**
 * Property names used for storing test metadata on modules, classes, and functions.
 */
export const keywords = {
  /** Property used to mark a test as 'only'. */
  only,
  /** Property used to store a custom title for a test. */
  title,
  /** Property used to store parameterized test cases. */
  cases,
  /** The standard name for a default export in a module. */
  defaultExport,
  /** A tag used to identify a module. */
  moduleTag
}
